import type { SaturatedOilViscosityParameters } from "../../d";

export function saturatedOilViscosityCalculator(
  params: SaturatedOilViscosityParameters
): {
  saturatedOilViscosity: number;
  y: number;
  f: number;
} {
  const { solutionGasRso, deadOilViscosity } = params;

  // Q120: =10**(-0.0008*J12)
  const y = 10 ** (-0.0008 * solutionGasRso);

  // Q122 =(0.2001+0.8428*10**(-0.000845*J12))*Q17**(0.43+0.5165*Q120)
  const f =
    (0.2001 + 0.8428 * 10 ** (-0.000845 * solutionGasRso)) *
    deadOilViscosity ** (0.43 + 0.5165 * y);

  // Q124 =-0.06821+0.9824*Q122+0.0004034*Q122**2
  const saturatedOilViscosity = -0.06821 + 0.9824 * f + 0.0004034 * f ** 2;
  return {
    saturatedOilViscosity,
    y,
    f
  };
}
